var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0_5627_107160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.667 5.616L8.376 8.752a3.709 3.709 0 00-3.1 4.311l3.49 20.233a3.868 3.868 0 004.387 3.154l10.007-1.546-1.69-9.9-2.579.398a.629.629 0 01-.712-.51l-.563-3.19a.603.603 0 01.503-.702l2.575-.398-.532-3.083c-.617-3.577 1.238-5.864 4.439-6.359l2.626-.406a.629.629 0 01.713.513l.464 2.69a.603.603 0 01-.503.701l-1.612.25c-1.74.269-1.935 1.146-1.727 2.356l.46 2.669 3.825-.591a.628.628 0 01.721.585l.171 3.249a.603.603 0 01-.512.628l-3.428.53 1.69 9.9 5.955-.92a3.708 3.708 0 003.099-4.31L33.053 8.77a3.868 3.868 0 00-4.386-3.154z",
    fill: "#85A5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0_5627_107160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.98827 -.15274 .16995 .98545 0 6)",
    d: "M0 0h36v36H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/facebook.48334086fc148e6796b26c077450ded0.svg";
export { SvgFacebook as ReactComponent };